import React, { useState, useContext, useEffect } from "react";
import { Modal } from "antd";
import { AuthContext } from "context/AuthContext";
import RectangleSelector from "ui/alerts/img-search/rectangleSelector";
import { uploadSign } from "pages/service";
import { showToast } from "ui/components/common";
import { Popover } from "react-tiny-popover";
import { AlertDataType } from "lib/types";
import {
  SvgAlertNonMotorVehicleType,
  SvgAlertPeopleType,
  SvgClose,
  SvgAlertStatusFilter,
  SvgAlertTimeRangeSelection,
  SvgAlertVehicleType,
  SvgAlertPrevPage,
  SvgAlertNextPage,
  SvgBell,
  SvgCamera,
  SvgDateSelection,
  SvgDisabledCamera,
  SvgMapMarker,
  SvgAlertSmokingType,
  SvgAlertConflagrationType,
  SvgInspection,
  SvgNoHardHat,
  SvgAlertGunType,
  SvgEye,
  SvgNoVest,
} from "ui/svgs";
import { formatContextDate } from "lib/utils";
import ImageDrag from "ui/alerts/img-search/img-drag";
import clsx from "clsx";
import dayjs from "dayjs";
import { fetchSites } from "lib/actions";
import Calendar from "pages/dashboard/schedule/components/calendar";
import SiteSelectPopover from "ui/components/site-select-popover";
import RecordModal from "ui/database/record-modal";

import type { FilterType } from "ui/alerts/img-search/img-search-modal-control";
export default function CropAlertImgForSearchModal({
  title,
  defaultImgUrl,
  isOpen,
  onRequestClose,
  onFinish,
  onFilterChange,
  filter,
}: {
  title?: string;
  defaultImgUrl: string;
  isOpen: boolean;
  onRequestClose: () => void;
  onFinish: (img: Blob, s3Key: string) => void;
  onFilterChange?: (filter: FilterType) => void;
  filter?: FilterType;
}) {
  const [imgUrl, setImgUrl] = useState("");
  const [addRecordModalOpen, setAddRecordModalOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [cropImg, setCropImg] = useState<Blob | null>(null);
  const [isDatePopoverOpen, setIsDatePopoverOpen] = useState(false);
  const [stagedDate, setStagedDate] = useState(
    filter?.startedAt
      ? formatContextDate(filter?.startedAt, {
          month: "short",
          day: "2-digit",
        })
      : "",
  );

  const [datePickerValue, setDatePickerValue] = useState(new Date());

  useEffect(() => {
    setImgUrl(defaultImgUrl);
  }, [defaultImgUrl]);

  useEffect(() => {
    if (!isOpen) {
      setImgUrl("");
    } else {
      setImgUrl(defaultImgUrl);
    }
  }, [isOpen]);

  const handleCropImg = async (cropImg: Blob) => {
    setCropImg(cropImg);
  };

  const handleUploadAndSearch = async () => {
    //onFinish(cropImg, s3Key);
    //return;
    setSubmitting(true);
    const res = await uploadSign(Math.random() + "-crop.jpg");
    if (res.status !== 200) {
      showToast(1, "Failed to get upload signaure. Please try again later");
      return;
    }
    //setS3Key(res.data.key);

    try {
      await fetch(res.data.uploadSignUrl, {
        method: "PUT",
        body: cropImg,
        headers: {
          "Content-Type": "image/jpeg",
        },
      });
    } catch (e) {
      console.error(e);
      showToast(1, "Failed to upload image. Please try again later");
      setSubmitting(false);
      return;
    }

    setSubmitting(false);
    //showToast(0, "Image uploaded successfully");
    onFinish(cropImg, res.data.key);
  };

  const handleCancelDate = () => {
    setStagedDate(null);
    setIsDatePopoverOpen(false);
  };

  const handleOkDate = () => {
    const startDate = new Date(datePickerValue);
    startDate.setHours(0, 0, 0, 0);

    const endDate = new Date(datePickerValue);
    endDate.setHours(23, 59, 59, 999);

    onFilterChange({ ...filter, startedAt: startDate, endedAt: endDate });

    setIsDatePopoverOpen(false);

    const formattedDate = formatContextDate(startDate, {
      month: "short",
      day: "2-digit",
    });
    setStagedDate(formattedDate);
  };

  const handleSite = (siteIds) => {
    onFilterChange({ ...filter, siteIds: [...siteIds] });
  };

  const clearDate = () => {
    onFilterChange({ ...filter, startedAt: undefined, endedAt: undefined });

    setStagedDate(null);
  };
  console.log("filter", filter);

  return (
    <Modal
      open={isOpen}
      onCancel={onRequestClose}
      footer={null}
      title={<span className="title">{title}</span>}
      width={1200}
      destroyOnClose={true}
      centered
    >
      <p className="text-[#222222] font-semibold">
        Drag to select an area for search
      </p>
      <div className="h-[651px] flex items-center justify-center relative mt-4">
        {imgUrl ? (
          <RectangleSelector imgUrl={imgUrl} onCropImg={handleCropImg} />
        ) : (
          <ImageDrag onImgUrlChange={(url) => setImgUrl(url)} />
        )}
      </div>
      <div className="flex justify-between items-center mt-4">
        <div className="flex items-center gap-4">
          <Popover
            isOpen={isDatePopoverOpen}
            positions={["top", "left", "right"]}
            onClickOutside={() => setIsDatePopoverOpen(false)}
            content={
              <div className="border rounded-xl shadow-xl bg-white w-[320px] p-4">
                <Calendar
                  onChange={(v) => {
                    const date = v.toDate();
                    date.setHours(0, 0, 0, 0);
                    setDatePickerValue(date);
                  }}
                  shifts={null}
                  defaultDate={
                    filter?.startedAt ? dayjs(filter?.startedAt) : dayjs()
                  }
                  children={null}
                />
                <div className="flex justify-end space-x-2 mt-4">
                  <button
                    className="px-4 py-2 rounded text-sm text-blue-700 hover:bg-gray-100"
                    onClick={handleCancelDate}
                  >
                    Cancel
                  </button>
                  <button
                    className="px-4 py-2 rounded text-sm text-blue-700 hover:bg-blue-200"
                    onClick={handleOkDate}
                  >
                    OK
                  </button>
                </div>
              </div>
            }
          >
            <div className="h-[60px] flex items-center">
              {stagedDate ? (
                <div className="flex gap-1 items-center rounded-xl bg-blue-100 px-3 py-2 h-[33px]">
                  <SvgDateSelection
                    width="20"
                    className="fill-blue-500 flex-shrink-0"
                  />
                  <span className="text-sm font-semibold text-left flex-grow text-nowrap">
                    {stagedDate}
                  </span>
                  <button onClick={clearDate}>
                    <SvgClose
                      width="13"
                      className="fill-neutral-800 hover:fill-neutral-700"
                    />
                  </button>
                </div>
              ) : (
                <button
                  className="flex items-center rounded-xl hover:bg-zinc-200 border border-neutral-400 px-3 py-2 w-[135px] h-[33px]"
                  onClick={() => setIsDatePopoverOpen(!isDatePopoverOpen)}
                >
                  <SvgDateSelection width="20" className="fill-blue-500" />
                  <p className="text-sm font-semibold text-left ml-1">
                    Select Date
                  </p>
                </button>
              )}
            </div>
          </Popover>
          <SiteSelectPopover
            onSitesChange={handleSite}
            selectedSites={filter?.siteIds}
            multiSelect={false}
          />
        </div>
        <div className="flex items-center">
          <button
            className="ml-4 rounded-2xl px-6 py-4 bg-white text-blue-500 border border-blue-500 text-sm font-medium  transition-colors hover:text-blue-400 disabled:text-blue-500  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:text-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
            disabled={submitting || cropImg === null}
            aria-disabled={submitting || cropImg === null}
            onClick={() => {
              setAddRecordModalOpen(true);
            }}
          >
            Save Selection
          </button>
          <button
            className="ml-4 rounded-2xl w-[152px] h-[52px] flex items-center justify-center bg-blue-500 text-sm font-medium text-white transition-colors hover:bg-blue-400 disabled:bg-blue-500  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
            disabled={submitting || cropImg === null}
            aria-disabled={submitting || cropImg === null}
            onClick={handleUploadAndSearch}
          >
            {submitting ? (
              <div
                className="ml-1 text-white  inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                role="status"
              ></div>
            ) : (
              " Search Selection"
            )}
          </button>
        </div>
      </div>

      <RecordModal
        editType={"add"}
        visible={addRecordModalOpen}
        onClose={() => setAddRecordModalOpen(false)}
        onSave={() => setAddRecordModalOpen(false)}
        img={cropImg}
      />
    </Modal>
  );
}
